import { cancel_feedback_post_path } from '@routes';

import request from './request';

export interface CancelRequest {
  reason: string;
  notes?: string;
}

export interface CancelResponse {
  success: boolean;
  redirectUri?: string;
}

export async function cancelConfirmation(params: CancelRequest) {
  const resp = await request('post', cancel_feedback_post_path(), params);
  return resp;
}
